import { useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { SubmitTaskRequestTypeEnum } from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';

type Request = {
  taskId: number;
  /** Campaign id, used to invalidate the campaign detail after submit. */
  campaignId: number;
  type: SubmitTaskRequestTypeEnum;
};

/**
 * Submits a social task for verification (state → VALIDATING). The backend then
 * asynchronously verifies the creator's post and moves the task to COMPLETED or
 * REJECTED; no post URL/media is sent from the client.
 */
export function useSubmitTask() {
  const queryClient = useQueryClient();

  return useApiMutation<void, AxiosError, Request>({
    mutationFn:
      (api) =>
      async ({ taskId, type }) => {
        await api.campaigns.campaignsControllerSubmitTask(taskId, { state: 'VALIDATING', type });
      },
    onSuccess: (_data, { campaignId }) => {
      return queryClient.invalidateQueries({ queryKey: campaignKeys.detail(campaignId) });
    },
  });
}
